import React, { useState } from "react";
import "./DashboardpagesCss/EditProfile.css";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { updateProfile } from "../../api/api";
import toast from "react-hot-toast";
import { logDOM } from "@testing-library/dom";
import { formatDate } from "../../utils/helper";

const EditProfile = () => {
    const { userData } = useOutletContext();
    const navigator = useNavigate();

    const location = useLocation();
    const profileData = location.state?.profileData;
    console.log("profileData===in edit>", profileData);

    // ✅ Extract profile safely
    const profile = profileData?.[0] || null;

    // ✅ Redirect if no valid data
    React.useEffect(() => {
        if (!profile) {
            toast.error("No profile data found. Please try again.");
            navigator(-1); // Go back or navigate to profile page
        }
    }, [profile, navigator]);

    const [isChecked, setIsChecked] = useState(false);

    const [formData, setFormData] = useState({
        mobile: profileData[0]?.mobile_no || "",
        altMobile: profileData[0]?.alt_mobile_no || "",
        firstName: profileData[0]?.PFirstName || "",
        lastName: profileData[0]?.PLastName || "",
        email: profileData[0]?.email || "",
        dob: profileData[0]?.dateofbirth || "",
        gender:
            profileData[0]?.PSex === "M"
                ? "male"
                : profileData?.PSex === "F"
                    ? "female"
                    : "other",
        address: profileData[0]?.address || "",
        landmark: profileData[0]?.landmark || "",
        state: profileData[0]?.State || "West Bengal",
        city: profileData[0]?.City || "",
        pincode: profileData[0]?.Zipcode || "",
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    console.log("formData==> in edit", formData);

    const handleSubmit = (e) => {
        e.preventDefault();
        editProfileApiCall();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({  
            ...prev,
            [name]: value,
        }));
    };
    // formet date
    //   const formatDateToDDMMYYYY = (dateString) => {
    //     if (!dateString) return "";
    //     const dateParts = dateString.split("-");
    //     return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
    //   };

    const formatDateToDDMMYYYY = (input) => {
        if (!input) return "";

        const date = new Date(input); // Handles both "YYYY-MM-DD" or Date object
        if (isNaN(date)) return ""; // invalid date guard

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    // console.log("formateddate", formatDateToDDMMYYYY("2008-07-11"));

    // ----------------------------call update profile api ----------------------------
    const editProfileApiCall = async () => {
        try {
            if (!isChecked) {
                toast.error("Allow RB Diagnostic to Call / Whatsapp / Mail / SMS");
                return; 
            }

            setLoading(true);
            setMessage(""); // reset message before call
            const today = new Date();

            const payload = {
                RBAuthKey: "RBDWAh!Q1s74e", // static
                user_id: profileData[0]?.user_id || "",
                PTitle: "",
                FName: formData.firstName || "",
                LName: formData.lastName || "",
                Mobile_no: formData.mobile || "",
                Alt_mobile_no: formData.altMobile || "",
                Email: formData.email || "",
                Dateofbirth: formatDateToDDMMYYYY(formData.dob) || "",
                Gender:
                    formData.gender === "male"
                        ? "M"
                        : formData.gender === "female"
                            ? "F"
                            : "O",
                Address: formData.address || "",
                Landmark: formData.landmark || "",
                ZipCode: formData.pincode || "",
                City: formData.city || "",
                State: formData.state || "",
                Reg_status: "0",
                Pat_status: "0",
                Registerdate: formatDateToDDMMYYYY(today),
                opt_check: isChecked,
            };
            console.log("final payload is ==>", payload);

            const res = await updateProfile(payload);

            if (res?.data?.status?.toLowerCase() === "success") {
                setMessage(res?.data?.message || "Request submitted successfully!");
                // setShowPopup(true); // ✅ show popup only on success
                const successMessage =
                    res?.data?.message || "Request submitted successfully!";
                toast.success(successMessage);

                navigator(-1);
                setFormData({
                    mobile: "",
                    altMobile: "",
                    firstName: "",
                    lastName: "",
                    email: "",
                    dob: "",
                    gender: "",
                    address: "",
                    landmark: "",
                    state: "",
                    city: "",
                    pincode: "",
                });

                setIsChecked(false); // uncheck checkbox
                // reset form

            } else {
                //  do nothing, no popup
                const errorMessage =
                    res?.data?.message || "Something went wrong. Please try again.";
                setMessage("Something went wrong. Please try again.");
                toast.error(errorMessage);
            }
        } catch (err) {
            console.error("Error submitting help request:", err);
            //  do nothing, no message, no popup
            // setMessage("Server error. Please try again later.",err);

            // setShowPopup(true);
            toast.error("Server error. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
     
        <div className="edit-profile-container">
            <div className="profile-header">
                <h2>Update Member Details</h2>
            </div>

            {/* <div className="edit-profile-form-wrapper"> */}
            <form className="edit-profile-form" onSubmit={handleSubmit}>
                
                <div className="edit-form-row">
                    <div className="form-group half-width form-group-dash">
                        <label>Mobile Number</label>
                        <input
                            type="tel"
                            name="mobile"
                            placeholder="mobile"
                            value={formData.mobile}
                            disabled
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group form-group-dash">
                        <label>Date of Birth</label>
                        <input
                            type="date"
                            name="dob"
                            value={formatDate(formData.dob)}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group half-width form-group-dash">
                        <label>First Name</label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group half-width form-group-dash">
                        <label>Last Name</label>
                        <input
                            type="text"
                            name="lastName"
                            // placeholder={userData.lastName}
                            value={formData.lastName}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="edit-form-row">
                    {/* <div className="form-group half-width form-group-dash">
                        <label>First Name</label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group half-width form-group-dash">
                        <label>Last Name</label>
                        <input
                            type="text"
                            name="lastName"
                            // placeholder={userData.lastName}
                            value={formData.lastName}
                            onChange={handleChange}
                        />
                    </div> */}
                </div>


                {/* <div className="form-row">
                    <div className="form-group half-width form-group-dash">
                        <label>First Name</label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group half-width form-group-dash">
                        <label>Last Name</label>
                        <input
                            type="text"
                            name="lastName"
                            // placeholder={userData.lastName}
                            value={formData.lastName}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group form-group-dash">
                        <label>Date of Birth</label>
                        <input
                            type="date"
                            name="dob"
                            value={formatDate(formData.dob)}
                            onChange={handleChange}
                        />
                    </div>
                </div> */}

                <div className="edit-form-row background-edit-form-row">
                    <div className="form-group form-group-dash">
                        <label>Email ID</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group half-width form-group-dash">
                        <label>Alternative Mobile</label>
                        <input
                            type="tel"
                            name="altMobile"
                            placeholder="Alt_Mobile"
                            value={formData.altMobile}
                            onChange={handleChange}
                            maxLength="10"
                            onInput={(e) => {
                                (e.target.value) = e.target.value.replace(/[^0-9]/g, '')
                            }}
                        />
                    </div>
                    <div className="form-group form-group-dash">
                        <label>Gender</label>
                        <div className="gender-options">
                            {["male", "female", "other"].map((g) => (
                                <label key={g}>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value={g}
                                        checked={formData.gender === g}
                                        onChange={handleChange}
                                    />{" "}
                                    {g.charAt(0).toUpperCase() + g.slice(1)}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div className="form-group half-width form-group-dash">
                        <label>Landmark</label>
                        <input
                            type="text"
                            name="landmark"
                            placeholder="Landmark"
                            value={formData.landmark}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group half-width form-group-dash">
                        <label>Address</label>
                        <input
                            type="text"
                            name="address"
                            placeholder="Address"
                            value={formData.address}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group form-group-dash">
                        <label>State</label>
                        <input
                            type="text"
                            name="state"
                            placeholder="State"
                            value={formData.state}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group  form-group-dash">
                        <label>City</label>
                        <input
                            type="text"
                            name="city"
                            placeholder="city"
                            value={formData.city}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group form-group-dash">
                        <label>Pin Code</label>
                        <input
                            type="text"
                            name="pincode"
                            placeholder="zipcode"
                            value={formData.pincode}
                            onChange={handleChange}
                            maxLength="6"
                            onInput={(e) => {
                                (e.target.value) = e.target.value.replace(/[^0-9]/g, '')
                            }}
                        />
                    </div>
                </div>


                <div className="consent-checkbox">
                    <label>
                        <input
                            type="checkbox"
                            className="mr-2"
                            checked={isChecked}
                            onChange={(e) => setIsChecked(e.target.checked)} 
                        />
                        I allow <b>RB Diagnostic</b> to Call / Whatsapp / Mail / SMS
                    </label>
                </div>

                {/* Buttons */}
                <div className="form-actions">
                    <button type="button" className="rbdButton reset-Btn submit-profile-btn">
                        <span className="btn-text">Back</span>
                    </button>
                    <button type="submit" className="rbdButton submit-profile-btn">
                        <span className="btn-text">Submit</span>
                    </button>
                </div>
            </form>
            {/* </div> */}
        </div>
    
    );
};

export default EditProfile;